<template>
  <section class="content-padding-gray">

    <div class="row">
      <div class="col-12 col-md-4">
        <form @submit.prevent="getWithHoldingTax">
          <div class="form-group">
            <label for="year"><span style="color:red;">*</span> เลือกปี</label>
            <select class="form-control" v-model="queryData.year" id="year" required @change="getWithHoldingTax()">
              <option value="">กรุณาเลือกปี</option>
              <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="month">เลือกเดือน</label>
            <select class="form-control" v-model="queryData.month" id="month" @change="getWithHoldingTax()">
              <option value="">ทุกเดือน</option>
              <option value="01">มกราคม</option>
              <option value="02">กุมภาพันธ์</option>
              <option value="03">มีนาคม</option>
              <option value="04">เมษายน</option>
              <option value="05">พฤษภาคม</option>
              <option value="06">มิถุนายน</option>
              <option value="07">กรกฎาคม</option>
              <option value="08">สิงหาคม</option>
              <option value="09">กันยายน</option>
              <option value="10">ตุลาคม</option>
              <option value="11">พฤศจิกายน</option>
              <option value="12">ธันวาคม</option>
            </select>
          </div>

          <div class="form-group">
            <button class="btn btn-primary" type="submit"><i class="fas fa-search"></i> ค้นหา</button>
          </div>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="text-danger pt-4 pb-4">
          <h4><i class="fas fa-info-circle"></i> เอกสารฉบับนี้สามารถดาวน์โหลดเพื่อใช้ยื่นขอคืนภาษี หัก ณ ที่จ่าย กับทางสรรพากรได้เลยค่ะ</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="table-responsive custom-scroll">
          <table class="table table-striped">
            <thead>
            <tr class="info">
              <th>#</th>
              <th class="text-center">เอกสาร</th>
              <th class="text-center">เดือน</th>
              <th class="text-right">ยอดก่อนภาษี</th>
              <th class="text-right">หัก ณ ที่จ่าย</th>
            </tr>
            </thead>
            <tbody>
            <template v-if="withHoldingTaxList.data && withHoldingTaxList.data.length > 0">
              <tr v-for="(item, index) in withHoldingTaxList.data[0].months_data" :key="'report_'+index">
                <td>{{ index + 1 }}</td>
                <td class="text-center" >
                  <!-- ใช้ is_approved_download เนื่องจากต้่องแบ่งการใช้แตกต่างจากระบบหลังบ้าน  -->
                  <div v-if="item.is_approved_download && item.is_approved_download.length > 0 && item.is_approved_download.some(item => item === 1)">
                    <a :href="getPDF(item)" class="btn btn-warning" target="_blank"><i class="fas fa-download"></i> ดาวน์โหลดเอกสาร</a>
                  </div>
                </td>
                <td class="text-center">{{ item.month | monthTH }} ({{ queryData.year }})</td>
                <td class="text-right">{{ item.total_prof_income | accounting }}</td>
                <td class="text-right">{{ item.total_withholding_tax_amount | accounting }}</td>
              </tr>
            </template>


            <tr v-if="withHoldingTaxList.summary">
              <td class="text-center" colspan="2" style="background-color: #DEDEDE">รวม:</td>
              <td></td>
              <td class="text-right">{{ withHoldingTaxList.summary.total_income | accounting }}</td>
              <td class="text-right">{{ withHoldingTaxList.summary.total_wht | accounting }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import axios from 'axios'
import _ from 'lodash'
import Header from './components/Header'

export default {
  name: 'ProfessionalWithHoldingTax',
  components: { Header },
  data () {
    return {
      queryData: {
        year: '',
        month: '',
        is_business: 0
      },
      withHoldingTaxList: {
        data: [],
        summary: {
          total_income: 0,
          total_wht: 0
        }
      }
    }
  },
  computed: {
    ...mapState({
      tokenTemp: state => state.auth.tokenTemp,
      tokenProfessional: state => state.auth.tokenProfessional,
      professional: state => state.auth.professional,
      adminBaseApiUrl: state => state.globalVal.adminBaseApiUrl
    }),

    years () {
      let start = 2016
      let end = moment().year() + 1
      return Array(end - start).fill().map((d, i) => i + start)
    }
  },
  methods: {
    async getWithHoldingTax () {
      let url = `${this.adminBaseApiUrl}/reports/professional-wht`

      try {
        const headers = { 'Authorization': `Bearer ${this.tokenTemp}` }
        const { data } = await axios.get(url, {
          params: {
            year: this.queryData.year,
            month: this.queryData.month,
            is_business: this.queryData.is_business,
            keyword: this.professional.id
          },
          headers
        })
        delete data['error']

        if (!data.data || data.data.length <= 0) {
          this.$swal({
            text: 'ไม่มีข้อมูลจากตัวกรองที่คุณเลือก',
            type: 'error'
          })
          this.withHoldingTaxList.data = []
          this.withHoldingTaxList.summary.total_income = 0
          this.withHoldingTaxList.summary.total_wht = 0
          return
        }

        this.withHoldingTaxList = _.cloneDeep(data)
      } catch (err) {
        if (err.message === 'Request failed with status code 401') {
          this.$swal({ text: 'รหัสผ่านหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง', type: 'error' })
          this.$store.dispatch('auth/LOGOUT_PROFESSIONAL')
          this.$router.replace({ name: 'Professional Login', query: { redirect_to: 'Professional With Holding Tax' } })
        } else {
          this.$swal({ title: 'ผิดพลาด กรุณาติดต่อเจ้าหน้าที่', text: err.message, type: 'error' })
        }
      }
    },
    getPDF (item) {
      const queryData = {
        ...this.queryData,
        month: item.month,
        ids: item.ids_approved
        // final_income: item.final_income,
        // wht: item.wht,
        // no: item.index
      }
      let token = this.tokenTemp
      return `${this.adminBaseApiUrl}/reports/professional-wht-pdf?${window.$.param(queryData)}&token=${token}`
    }
  }
}
</script>

<style scoped>
.custom-scroll::-webkit-scrollbar-track {
  border: 1px solid #000;
  padding: 2px 0;
  background-color: #404040;
}

.custom-scroll::-webkit-scrollbar {
  width: 10px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #00BCD4;
  border: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// src/components/professional/ProfessionalWithHoldingTax.vue